import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdministrativeService } from '../../services/adiq/administrative/administrative.service';
import { PinPadService } from '../../services/adiq/pinpad/pinpad.service';
import { DateUtilService } from '../../services/date-util.service';
import * as moment from 'moment';

export class PinPadComponent {
  constructor(
    public notificationService: NotificationsService,
    public spinnerService: NgxSpinnerService,
    public dateUtilService: DateUtilService,
    public pinPadService: PinPadService,
    public administrativeService: AdministrativeService,
  ) {
  }
  public pinpadIsInit: boolean = false;
  public serialNumber = null;
  public pinpadInfo: any = null;
  public terminalModel: any = null;
  public enterpriseFederalId: string;
  public listTerminais: Array<any> = [];
  public identificaTerminal = false;
  public port: any = null;

  async pinpadInit() {
    let responseAlive: any = null;
    try {
      responseAlive = await this.pinPadService.pinpadAlive().toPromise();
      this.verifyPinpadStatus(responseAlive.body);


    }catch (error) {
      this.pinpadIsInit = false;
        this.notificationService.error
        ('Não foi possível conectar-se ao Pinpad. Favor, verificar se a aplicação está iniciada!');
        throw error;
    }

  }

  setup() {

    this.spinnerService.show()

   let data: any = null;
   data = {
     codigo_estabelecimento: '000000000000000',
     codigo_rede_autorizadora: '000000',
     codigo_terminal: '000000000000000',
     tipo_terminal: 'WTDZZ100',
   };


   this.administrativeService.setup(data).subscribe((response) => {
     this.terminalModel = this.terminalLocalizado;
     this.pinpadIsInit = true;
     localStorage.setItem(
       'pinpadConfigGertec',
        JSON.stringify({type: 'gertec' , port: String(this.port.data['port[0]']) , 'serialNumber': this.serialNumber,  lastCharge: moment(new Date()).format('YYYY-MM-DD')})
     );
     this.spinnerService.hide()

   }, (error) => {
     this.notificationService.error('Falha na inicialização')
     this.spinnerService.hide()

   });
  }

  getSerialNumber(data: any) {
    this.serialNumber = data;
  }

  async verifyPinpadStatus(data: any) {
    this.port = await this.pinPadService.findPorts().toPromise();
    if (data.returnValue === 'PPCOMP_NOTOPEN') {
      this.ativarPinPad();
    }else {
      await this.buscarNumeroSerie();
    }

  }

  async buscarNumeroSerie() {
    this.serialNumber = await this.pinPadService.getSerial().toPromise();
      if (this.serialNumber.returnValue === 'PPCOMP_OK') {
        this.serialNumber = this.serialNumber.data.serial;
      }
    this.identificarTerminal();
  }

  async ativarPinPad() {
    this.port = await this.pinPadService.findPorts().toPromise();
    this.identificaTerminal = true;
    let conectado = false;

    if (this.port.returnValue === 'PPCOMP_OK') {
      for (let key in this.port.data) {
        if(!conectado){
          if (this.port.data.hasOwnProperty(key)) {
            conectado = await this.conectaPorta(this.port.data[key]);
          }
        }
      }
      if(!conectado){
        this.notificationService.error('Pinpad não conectado');
      }
    } else {
      this.pinpadIsInit = false;
      this.notificationService.error('Pinpad não conectado');
    }

  }

  async conectaPorta(data :any){
    await this.pinPadService.closePort().toPromise();
    let params = new HttpParams();
    params = params.append('port', String(data));
    const resp: any = await this.pinPadService.openPort(params).toPromise();

    if (resp.returnValue !== 'PPCOMP_OK') {
      return false;
    }else{
      await this.buscarNumeroSerie();
      return true;
    }
  }


  async desativarPinPad() {
    try{
      await this.pinPadService.closePort().toPromise();
    }catch(error) {
      this.notificationService.error('Não foi possível fechar a conexão anterior')
    }
  }


  setPinpadInitValues() {
    if (this.pinpadInfo != null) {
      this.listTerminais.forEach((terminal) => {
        if ( terminal.numeroSerie === this.pinpadInfo.numeroSerie &&
           terminal.codigoEstabelecimento ===  this.pinpadInfo.codigoEstabelecimento &&
          terminal.codigoTerminal === this.pinpadInfo.codigoTerminal
        ) {
     //     this.terminalModel = terminal;
        }
      });
    }
  }

  public terminalLocalizado: any = null;
  public terminalLocalizadoInfoText: string = 'Localizando terminal...';

  forceIdentificarTerminal(){
    if(this.terminalLocalizadoInfoText === 'Localizando terminal...'){
      return;
    }

    this.identificarTerminal();
  }

  identificarTerminal() {
    let pinpadConfig: any = localStorage.getItem('pinpadConfigGertec');

    this.terminalLocalizadoInfoText = 'Localizando terminal...';
    if (this.listTerminais == null || this.listTerminais.length === 0) {
      this.notificationService.warn('A lista de terminais não foi carregada.');
      this.terminalLocalizadoInfoText = 'A lista de terminais não foi carregada.';
      return;
    }

    if (this.serialNumber == null){
      this.notificationService.warn('Terminal não localizado.');
      this.terminalLocalizadoInfoText = 'Terminal não localizado.';
      return;
    }

    const terminaisFilter: Array<any> =
      this.listTerminais.filter(terminal => terminal.numeroSerie === this.serialNumber);
    if (terminaisFilter != null && terminaisFilter.length > 0) {
      this.terminalLocalizado = terminaisFilter[0];

      if (this.serialNumber !== this.terminalLocalizado.numeroSerie) {
        this.notificationService.warn("O terminal selecionado não corresponde ao terminal conectado.");
        return;
      }


      this.terminalLocalizadoInfoText = 'Terminal: '.concat(this.terminalLocalizado.numeroSerie);

      if (pinpadConfig != null) {
        pinpadConfig = JSON.parse(pinpadConfig);
        if (
          pinpadConfig.type !== "gertec" ||
          pinpadConfig.lastCharge !== moment(new Date()).format("YYYY-MM-DD") ||
          pinpadConfig.port !== this.port.data['port[0]'] ||
          pinpadConfig.serialNumber !== this.serialNumber
        ) {
          this.setup();
        }else{
          this.terminalModel = this.terminalLocalizado;
          this.pinpadIsInit = true;
        }
      } else {
        this.setup();
      }

    }else {
      this.notificationService.warn('Terminal não se encontra na lista de terminais.');
      this.terminalLocalizadoInfoText = 'Terminal não se encontra na lista de terminais.';
      return;
    }

  }

}
